import { cn } from "@discovery/classnames";
import { NavDirection, } from "../../components/atoms/carousel-nav";
import { Icon, Icons } from "../../components/atoms/icon";
import * as styles from "./styles.css";
const TabbableNav = ({ className, onClick, tabIndex, direction, }) => (React.createElement("button", { onClick: onClick, className: cn(className, {
        [styles.goToNext]: direction === NavDirection.Next,
        [styles.goToPrev]: direction === NavDirection.Prev,
    }), "aria-label": direction, tabIndex: tabIndex }, direction === NavDirection.Prev ? (React.createElement(Icon, { type: Icons.LeftArrowC })) : (React.createElement(Icon, { type: Icons.RightArrowC }))));
export const GoToPrev = (props) => (React.createElement(TabbableNav, Object.assign({}, props, { direction: NavDirection.Prev })));
export const GoToNext = (props) => (React.createElement(TabbableNav, Object.assign({}, props, { direction: NavDirection.Next })));

